module.exports = __webpack_public_path__ + "static/media/montserrat-latin-ext-400-normal.75ba6196.woff2";